module.exports = __webpack_public_path__ + "img/Stolly_logo.148d8170.png";